import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'

import ToggleGroup from './Common/ToggleGroup'

const Wrap = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  height: 70px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.25);
  padding: 0 76px;
  position: relative;
  z-index: 3;

  .rightCol {
    margin-left: auto;
  }

  @media (max-width: 1280px) {
    padding: 0 38px;
  }
`

const InnerWrap = styled.div`
  @media (min-width: 1280px) {
    max-width: 1280px;
    width: 100%;
    margin: auto;
  }
`

const LogoWrap = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 50px;
    border-radius: 5px;
    object-fit: contain;
    margin-right: 20px;
  }

  h1 {
    font-weight: 500;
    font-size: 16px;

    @media (max-width: 767px) {
      font-size: 12px;
    }
  }
`

const ToggleGroupStyled = styled(ToggleGroup)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export type TabViewValue = 'calendar' | 'approval' | 'instagramGrid'

export interface NavbarTabView {
  defaultValue: TabViewValue
  leftItem: { value: TabViewValue; label: string }
  middleItem?: { value: TabViewValue; label: string }
  rightItem: { value: TabViewValue; label: string }
  onViewChange: (view: TabViewValue) => void
}
export interface NavbarProps {
  logo: string
  name: string
  view?: NavbarTabView
}

const Navbar: React.FC<NavbarProps & React.HTMLAttributes<HTMLDivElement>> = ({
  logo,
  name,
  view,
  ...props
}) => {
  const isMobile = useMediaQuery({ maxWidth: 906 })

  return (
    <Wrap className={props.className}>
      <InnerWrap>
        <LogoWrap>
          <img src={logo} alt={name} />
          <h1>{name}</h1>
        </LogoWrap>

        {!isMobile && view && (
          <ToggleGroupStyled
            defaultValue={view.defaultValue}
            leftItem={{
              value: view.leftItem.value,
              label: view.leftItem.label,
            }}
            {...(view.middleItem
              ? {
                  middleItem: {
                    value: view.middleItem.value,
                    label: view.middleItem.label,
                  },
                }
              : undefined)}
            rightItem={{
              value: view.rightItem.value,
              label: view.rightItem.label,
            }}
            onValueChange={(value) => view.onViewChange(value as TabViewValue)}
            size="md"
          />
        )}
      </InnerWrap>
    </Wrap>
  )
}

export default Navbar
